<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
        </section>
        <main class="wrapper-404">
            <div class="error-404">
              <h1>
                页面飞到外太空了~~找不回来啦
              </h1>
                <div class="error-number"><span>4</span><span><img class="icon has-animation" src="https://image.flaticon.com/icons/svg/179/179595.svg" alt=""/></span><span>4</span></div>
              </div>
        </main>

    </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>



// WEBPACK FOOTER //
// 404.vue?0bc09fc3